import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import Site from '../stores/Site'

export default class Slider {
    constructor({wrapper, amount, amountTablet, disabledMobile = false, disabledDesktop = false, amountMobile, gap, centeredSlides, autoplay}) {
        if ((Site.isMobile && disabledMobile) || (!Site.isMobile && disabledDesktop)) return

        const numSlides = wrapper.querySelectorAll('.swiper-slide').length
        const el = wrapper.querySelector('.swiper')
        const pagination = wrapper.querySelector('.swiper-pagination')
        const nextEl = wrapper.querySelector('.swiper-button-next')
        const prevEl = wrapper.querySelector('.swiper-button-prev')

        const loop = numSlides > amount

        if (numSlides < 3 && !loop) {
            el.classList.add('centered')
        }

        const args = {
            modules: [ Navigation, Pagination, Autoplay ],
            speed: 400,
            slidesPerView: amountMobile,
            spaceBetween: gap,
            slideVisibleClass: 'swiper-slide-visible',
            loop,
            centeredSlides: centeredSlides && amountMobile > 1,
            breakpoints: {
                500: {
                    slidesPerView: amountTablet,
                    centeredSlides: centeredSlides && amountTablet > 1
                },
                1100: {
                    slidesPerView: amount,
                    centeredSlides: centeredSlides && amount > 1 && numSlides > amount
                }
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            navigation: {
                nextEl,
                prevEl
            }
        }

        if (numSlides <= amount) {
            wrapper.classList.add('slider-no-loop')
        }

        if (autoplay) {
            args.autoplay = {
                delay: 4000
            }
        }

        new Swiper(el, args)
    }
}